<script setup>
const props = defineProps({
  area: {
    type: String,
    default: ''
  }
})
const areaName = getJpAreaName(props.area)
const { $ads } = useNuxtApp()
const { data: recommendList } = await useFetch('/api/golf/ranking', { query: { limit: '', area: props.area } })
onMounted(() => {
  $ads.init(adsConfig)
})
</script>

<template>
  <section class="golfRecommend">
    <div class="title">
      <CommonPageTitle
        :title="`今人気のゴルフ場（${areaName}）`"
      />
      <p>※約2400地点のゴルフ場のページのアクセス数をはじめ、独自の基準に基づき順位を算出しています。</p>
    </div>
    <div class="block">
      <template
        v-for="(item, rank, index) in recommendList"
        :key="index"
      >
        <template v-if="index % 5 === 0 && index !== 0">
          <slot name="ads-btf">
            <div
              :id="`2.5web_golf_ranking_btf${index}`"
              class="ads-btf"
            />
          </slot>
        </template>
        <GolfRecommendItem
          :content="item"
          :rank="Number(rank)"
        />
        <template v-if="index === 0">
          <slot name="ads-atf">
            <div
              id="2.5web_golf_ranking_atf"
              class="ads-atf"
            />
          </slot>
        </template>
      </template>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.golfRecommend {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .title {
    p {
      font-size: 12px;
      color: #101010;
    }
  }
  .block {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}
.ads-atf {
  min-height: 50px;
  margin: 0px auto 10px;
  text-align: center;
  position: relative;
}
.ads-btf {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
